import type React from 'react';
import { shallowEqual } from 'react-redux';
import type { PropsWithChildren } from 'react';
import { useTypedSelector } from '../../Store/connectors';
import TranslationProvider from '../../../general/Translation/TranslationProvider';

const WithTranslationProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const dictionary = useTypedSelector(
    ({ translations }) => translations,
    shallowEqual,
  );
  return (
    <TranslationProvider dictionary={dictionary}>
      {children}
    </TranslationProvider>
  );
};

export default WithTranslationProvider;
